import { api } from "../utils/AuthManager";
import startOfWeek from "date-fns/startOfWeek";
import format from "date-fns/format";
const GetPowerFactor = async (id, date) => {
  return api
    .get(`/api/total_power_factor/${parseInt(id)}`, {
      params: {
        date: format(startOfWeek(date), "yyyy-MM-dd"),
      },
    })

    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default GetPowerFactor;
